import DateFnsUtils from "@date-io/date-fns";
import { Grid, Button, makeStyles } from "@material-ui/core";
import {
	KeyboardDatePicker,
	MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import moment from "moment";
import { useForm } from "react-hook-form";

const useStyles = makeStyles((theme) => ({
	root: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		gap: 10,
		[theme.breakpoints.down("xs")]: {
			flexDirection: "column",
		},
	},
	button: {
		height: 55,
		[theme.breakpoints.down("xs")]: {
			width: "80%",
		},
	},
}));

export const FormPickers = ({ state, setState, handleSearch }) => {
	const { handleSubmit } = useForm();

	const classes = useStyles();

	return (
		<Grid className={classes.root}>
			<MuiPickersUtilsProvider utils={DateFnsUtils}>
				<KeyboardDatePicker
					autoOk
					variant="inline"
					inputVariant="outlined"
					label="Start Date"
					format="MM/dd/yyyy"
					size="large"
					value={state.tgl_awal}
					onChange={(e) =>
						setState({ ...state, tgl_awal: moment(e).format("YYYY-MM-DD") })
					}
				/>
			</MuiPickersUtilsProvider>
			<MuiPickersUtilsProvider utils={DateFnsUtils}>
				<KeyboardDatePicker
					autoOk
					title="end date"
					variant="inline"
					inputVariant="outlined"
					label="End Date"
					size="large"
					format="MM/dd/yyyy"
					value={state.tgl_akhir}
					onChange={(e) =>
						setState({ ...state, tgl_akhir: moment(e).format("YYYY-MM-DD") })
					}
				/>
			</MuiPickersUtilsProvider>
			<Button
				variant="contained"
				color="primary"
				onClick={handleSubmit(handleSearch)}
				className={classes.button}
			>
				Search
			</Button>
		</Grid>
	);
};

export default FormPickers;
